var map = {
	"./left-a-1.png": "9177",
	"./left-a-2.png": "cff5",
	"./left-a-3.png": "1bc6",
	"./left-a-4.png": "7e32",
	"./left-a-5.png": "dbf2",
	"./left-a-6.png": "b99c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3e3d";